export default {
  methods: {
    formatDate(date) {
      let format = 'MM/DD/YY hh:mm a';
      return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').format(format);
    },
    formatShortDate(date) {
      let format = 'D MMM, YYYY';
      return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').format(format);
    },
	  formatTimeDate(date) {
      let format = 'hh:mm a';
      return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').format(format);
    },
    formatDateAndTime(date) {
      let format = 'YYYY-MM-DD HH:mm:ss';
      return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').format(format);
    },
    formatThreeDigitMonth(date) {
      let format = 'MMM. Do, YYYY';
      return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSSZ').format(format);
    },
    formatZoneDateTime(date, startDate = true) {
      const format = 'YYYY-MM-DDTHH:mmZ';
      let newDate = moment(date);

      if (startDate) {
        newDate = newDate.hours(0).minutes(0);
      } else {
        newDate = newDate.hours(23).minutes(59);
      }

      return newDate.format(format);
    }
  }
}